import { useState } from 'react'

import { useVisibility } from '@/src/general/hooks/useVisibility'
import { GTM } from '@/src/general/utils/gtm'
import { EVENTS } from '@/src/general/utils/gtm/constants'

export const useSuggestionsVisibility = () => {
  const [hasEventBeenSent, setHasEventBeenSent] = useState(false)
  const visibilityProps = useVisibility({
    percentHeight: 75,
    percentWidth: 1,
    onVisibilityChange: (isVisible) => {
      if (isVisible && !hasEventBeenSent) {
        GTM.sendEvent(EVENTS.SUGGESTIONS_SECTION_VISIBLE)
        setHasEventBeenSent(true)
      }
    },
  })
  return visibilityProps
}
